<template>
  <eight-wide-column>
    <segment>
      <div
        class="ui sub header"
        style="margin-top: 1rem;">
        {{ $t('actions.mobilePreview') }}
      </div>
      <!-- Preview -->
      <div
        class="ui fluid card"
        style="background-color: #222a34; width: 24.5rem;">
        <div
          class="content"
          style="color: white;">
          <div
            class="ui inverted header"
            style="color: white;">
            {{ item.data.title }}
            <div
              v-if="item.data.options.userTracking.status===true"
              class="sub header">
              <i class="clock icon"/>{{ $tc('actions.byToday') }}
            </div>
          </div>
          <div v-html="item.data.body"/>
        </div>
        <div
          v-if="item.data.options.userTracking.status===true"
          class="extra content">
          <button class="ui small secondary button">
            {{ $tc('actions.incomplete') }}
          </button>
          <button class="ui right floated primary small button">
            <i
              class="yellow star icon"
              style="opacity: 1;"/>{{ $tc('actions.completed') }}
          </button>
        </div>
      </div>
    </segment>
  </eight-wide-column>
</template>

<script>
import EightWideColumn from '../utility/EightWideColumn'
import Segment from '../utility/Segment'

export default {
  name: 'ActionPreview',
  components: { Segment, EightWideColumn },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.primary,
.secondary {
  background-color: #3e838a !important;
}
</style>
